
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@embroider/util/-embroider-implicit-modules.js";
